import { render, staticRenderFns } from "./colorbar.vue?vue&type=template&id=7362d4fc&scoped=true&"
import script from "./colorbar.vue?vue&type=script&lang=js&"
export * from "./colorbar.vue?vue&type=script&lang=js&"
import style0 from "./colorbar.vue?vue&type=style&index=0&id=7362d4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7362d4fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7362d4fc', component.options)
    } else {
      api.reload('7362d4fc', component.options)
    }
    module.hot.accept("./colorbar.vue?vue&type=template&id=7362d4fc&scoped=true&", function () {
      api.rerender('7362d4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/emap/KXD_VUE_MAP/src/packages/KXD-map/component/colorbar.vue"
export default component.exports